var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDistribution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.815 15.024v12.258c0 .76-.61 1.377-1.37 1.385l-12.39.133a1.385 1.385 0 0 1-1.4-1.4l.133-12.39a1.385 1.385 0 0 1 1.385-1.37H27.43c.764 0 1.384.62 1.384 1.384z",
    fill: "#78D9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.995 8.306v25.69c0 1.016-.82 1.84-1.836 1.846l-25.832.143a1.846 1.846 0 0 1-1.857-1.856l.143-25.833A1.846 1.846 0 0 1 8.459 6.46h25.69c1.02 0 1.846.827 1.846 1.846z",
    strokeOpacity: 0.4,
    stroke: "#78D9EB",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.71 10.13v22.042c0 .761-.614 1.38-1.375 1.385l-22.188.145a1.385 1.385 0 0 1-1.393-1.394l.145-22.188a1.385 1.385 0 0 1 1.384-1.376h22.043c.765 0 1.385.62 1.385 1.385z",
    stroke: "#78D9EB",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDistribution);
export default __webpack_public_path__ + "static/media/icon-distribution.2763ea3e1294e043a329e74d964913cc.svg";
export { ForwardRef as ReactComponent };